import React from "react";
import "./Revolutionizing_Travel.css";

function Revolutionizing_Travel() {
  return (
    <>
      <section className="Revolutionizing_Travel">
        <div className="container">


          <div className="content-holder">
            <div className="row">
              <div className="col-md-5">
                <div className="heading-holder">
                  <h4 className="heading title">Videowala Bus Stand:</h4>
                </div>
                <div className="sub-heading-holder">
                  <h4 className="heading eta_text ">ETA Updates</h4>
                </div>
              </div>

              <div className="col-md-7">
                <div className="eta_speed_div">
                  <p>Revolutionizing Travel with <br />
                    <span className="heading">Real-Time ETA Updates</span>
                  </p>
                </div>
                <div className="text-holder">
                  <p>
                    In a world where time is of the essence, Videowala Bus Stand
                    introduces an innovative solution to simplify and enhance
                    the travel experience for passengers. Our unique feature
                    provides real-time Estimated Time of Arrival (ETA) updates
                    for all vehicles, offering unmatched convenience and
                    reliability.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Revolutionizing_Travel;
